import { useEffect, useState } from 'react';

import {
  type UseQueryOptions,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

type MediaDevices = {
  audioDevices: Array<MediaDeviceInfo>;
  videoDevices: Array<MediaDeviceInfo>;
};

const getMediaDevices = async (): Promise<MediaDevices> => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const audioDevices = devices.filter((device) => device.kind === 'audioinput');
  const videoDevices = devices.filter((device) => device.kind === 'videoinput');

  return {
    audioDevices,
    videoDevices,
  };
};

export const useGetVideoRecorderSourcesQuery = (
  options?: Partial<UseQueryOptions<MediaDevices>>
) => {
  const queryClient = useQueryClient();
  const [permissionsGranted, setPermissionsGranted] = useState(false);

  useEffect(() => {
    const handlePermissions = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        setPermissionsGranted(true);
        queryClient.invalidateQueries({ queryKey: ['video-player-sources'] });
      } catch (error) {
        console.error('Permissions not granted', error);
      }
    };

    handlePermissions();
  }, [queryClient]);

  return useQuery<MediaDevices>({
    queryKey: ['video-player-sources'],
    enabled: permissionsGranted,
    queryFn: getMediaDevices,
    ...options,
  });
};
